import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CreditForm = ({ isOpen, onClose }) => {
    const [clientData, setClientData] = useState([]);
    const [formData, setFormData] = useState({
        amount: '',
        date: '',
        description: ''
    });

    useEffect(() => {
        const fetchClients = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/clients/all_clients`);
                if (response.status === 200) {
                    const formattedClients = response.data.client.map(client => ({
                        id: client.id,
                        companyName: client.companyname,
                        clientPhone: client.phone,
                        clientAddress: client.address,
                        clientLpo: client.lponumber
                    }));
                    setClientData(formattedClients);
                } else {
                    console.error(`Error: ${response.status} - ${response.statusText}`);
                }
            } catch (error) {
                console.error(error);
            }
        };
        fetchClients();
    }, []);

    const handleClientChange = selectedClientName => {
        const selectedClient = clientData.find(client => client.companyName === selectedClientName);
        if (selectedClient) {
            setFormData({
                ...formData,
                amount: '',
                date: '',
                description: '',
                clientid: selectedClient.id,
                clientphone: selectedClient.clientPhone,
                clientaddress: selectedClient.clientAddress,
                clientlpo: selectedClient.clientLpo,
                clientname: selectedClient.companyName
            });
        }
    };

    const handleInputChange = event => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const addCredit = async () => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/credits/add_credit`, {
                formData
            })
            if (res.status >= 200 && res.status < 300) {
                toast("Credit Note created successfully!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleSubmit = event => {
        event.preventDefault();
        addCredit()
        setFormData({
            ...formData,
            amount: '',
            date: '',
            description: ''
        });
    };

    return (
        <div className='z-[99999999999]' style={{ display: isOpen ? 'block' : 'none' }}>
            <div style={{ background: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }} onClick={onClose}></div>
                <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className='md:w-[50%] rounded-md' style={{ background: '#fff', position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', padding: '20px', zIndex: 999 }}>
                <div className='flex flex-col justify-center items-center gap-1'>
                    <form className='flex flex-col justify-center items-center gap-3' onSubmit={handleSubmit} style={{ width: '90%' }}>

                        <select name="clientname" value={formData.clientname} onChange={e => handleClientChange(e.target.value)} style={{ width: '100%', padding: '0.5rem', borderRadius: '0.5rem', border: '1px solid #ccc' }}>
                            <option className='disabled' value="">Select Client</option>
                            {clientData.map(client => (
                                <option key={client.id} value={client.companyName}>{client.companyName} (ID:{client.id})</option>
                            ))}
                        </select>

                        <input
                            type="text"
                            name="amount"
                            value={formData.amount}
                            onChange={handleInputChange}
                            placeholder="Amount"
                            required
                            style={{ width: '100%', padding: '0.5rem', borderRadius: '0.5rem', border: '1px solid #ccc' }}
                        />

                        <input
                            type="date"
                            name="date"
                            value={formData.date}
                            onChange={handleInputChange}
                            placeholder="Date"
                            required
                            style={{ width: '100%', padding: '0.5rem', borderRadius: '0.5rem', border: '1px solid #ccc' }}
                        />

                        <input
                            type="text"
                            name="description"
                            value={formData.description}
                            onChange={handleInputChange}
                            placeholder="descriptionription (any)"
                            style={{ width: '100%', padding: '0.5rem', borderRadius: '0.5rem', border: '1px solid #ccc' }}
                        />

                        <button type="submit" style={{ width: '100%', padding: '0.5rem', borderRadius: '0.5rem', border: 'none', backgroundColor: '#007bff', color: '#fff', cursor: 'pointer' }}>Create Credit Note</button>
                    </form>
                    <button onClick={onClose} style={{ width: '90%', padding: '0.5rem', borderRadius: '0.5rem', border: 'none', backgroundColor: '#6c757d', color: '#fff', cursor: 'pointer', marginTop: '1rem' }}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default CreditForm;
